import apiClient from './apiClient';
import { GET_ADDITIONAL_ITEM_TYPE_URL } from './apiUrl';

export const getAdditionalItemTypeApi = () => {
  return apiClient.get(GET_ADDITIONAL_ITEM_TYPE_URL);
};
